<template>
    <div class="loader">
        <span class="sr-only">{{ this.$root.config.translations.misc.loading.label }}</span>
    </div>
</template>
